import React, { ReactElement } from 'react';
import { Route, Routes } from 'react-router-dom';
import ProductReportingContainer from './productReporting';
import ProductsContainer from './productsReportingList';

const ProductsReportingRouter = (): ReactElement => (
  <Routes>
    <Route path="products/:productId/sprints/:sprintId" element={<ProductReportingContainer />} />
    <Route path="*" element={<ProductsContainer />} />
  </Routes>
);

export default ProductsReportingRouter;
